export default "__VITE_ASSET__DoeAtRHx__"